export default {"src":"/_next/static/media/WMB.1fca65cf.svg","height":18,"width":18};